/**
 * How long a request waits with no answer before the kit's pending spinner shows for it, in ms (ADR-061's note for
 * P2.8-T41). An answer normally comes within a tick or two, so a spinner drawn at once would only flicker; the
 * author asked that it show "only if the server doesn't respond within 1 or 2 seconds", and the coordinator chose
 * 1.5 s inside that. Every surface that shows the spinner waits this long.
 */
export const PENDING_SPINNER_DELAY_MS = 1500;

/**
 * Runs `run` once after `ms`, returning a way to cancel it: what a store that marks a slow request is given, so a
 * test can run its clock by hand.
 */
export type PendingTimer = (run: () => void, ms: number) => () => void;

/**
 * The page's timer, on `setTimeout`.
 *
 * @param run What to run.
 * @param ms After how long.
 * @returns Cancels it.
 */
export const PAGE_PENDING_TIMER: PendingTimer = (run, ms) => {
  const timer = setTimeout(run, ms);
  return () => clearTimeout(timer);
};
